import { render, staticRenderFns } from "./Transfer_WasteAll.vue?vue&type=template&id=6308d2d4&scoped=true"
import script from "./Transfer_WasteAll.vue?vue&type=script&lang=js"
export * from "./Transfer_WasteAll.vue?vue&type=script&lang=js"
import style0 from "./Transfer_WasteAll.vue?vue&type=style&index=0&id=6308d2d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6308d2d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VContainer,VDivider,VIcon,VLayout,VSpacer})
